import { List } from '../objects/list';
import { Error } from '../objects/error';
import { Preferences } from '../../profile/objects/preferences';
import { ManualAccommodationChain } from '../objects/manualAccommodationChain';
import { Column } from '../objects/column';

export const ADD_PREFERENCES = 'MANUAL_ACCOMMODATION_CHAIN_ADD_PREFERENCES';
export const MOVE_DOWN_COLUMN = 'MANUAL_ACCOMMODATION_CHAIN_MOVE_DOWN_COLUMN';
export const MOVE_UP_COLUMN = 'MANUAL_ACCOMMODATION_CHAIN_MOVE_UP_COLUMN';
export const RESET_CHAIN = 'MANUAL_ACCOMMODATION_CHAIN_RESET_CHAIN';
export const RESET_FILTERS = 'MANUAL_ACCOMMODATION_CHAIN_RESET_FILTERS';
export const SET_CHAIN = 'MANUAL_ACCOMMODATION_CHAIN_SET_CHAIN';
export const SET_ERRORS = 'MANUAL_ACCOMMODATION_SET_ERRORS';
export const SET_EXPORT_TYPE = 'MANUAL_ACCOMMODATION_CHAIN_SET_EXPORT_TYPE';
export const SET_LIMIT = 'MANUAL_ACCOMMODATION_CHAIN_SET_LIMIT';
export const SET_LIST = 'MANUAL_ACCOMMODATION_CHAIN_SET_LIST';
export const SET_ORDER_BY = 'MANUAL_ACCOMMODATION_CHAIN_SET_ORDER_BY';
export const SET_PAGE = 'MANUAL_ACCOMMODATION_CHAIN_SET_PAGE';
export const SET_POST_FINISHED = 'MANUAL_ACCOMMODATION_CHAIN_SET_POST_FINISHED';
export const SET_PREFERENCES = 'MANUAL_ACCOMMODATION_CHAIN_SET_PREFERENCES';
export const SET_RUNNING = 'MANUAL_ACCOMMODATION_CHAIN_SET_RUNNING';
export const SET_SEARCH = 'MANUAL_ACCOMMODATION_CHAIN_SET_SEARCH';
export const TOGGLE_COLUMN = 'MANUAL_ACCOMMODATION_CHAIN_TOGGLE_COLUMN';
export const TOGGLE_CREATE = 'MANUAL_ACCOMMODATION_CHAIN_TOGGLE_CREATE';
export const TOGGLE_EDIT = 'MANUAL_ACCOMMODATION_CHAIN_TOGGLE_EDIT';
export const TOGGLE_EXPORT = 'MANUAL_ACCOMMODATION_CHAIN_TOGGLE_EXPORT';
export const TOGGLE_EXPORT_FULL = 'MANUAL_ACCOMMODATION_CHAIN_TOGGLE_EXPORT_FULL';
export const TOGGLE_FILTERS = 'MANUAL_ACCOMMODATION_CHAIN_TOGGLE_FILTERS';
export const TOGGLE_REFRESH = 'MANUAL_ACCOMMODATION_CHAIN_TOGGLE_REFRESH';
export const UPDATE_FILTER_CREATED_DATE_GTE = 'MANUAL_ACCOMMODATION_CHAIN_UPDATE_FILTER_CREATED_DATE_GTE';
export const UPDATE_FILTER_CREATED_DATE_LTE = 'MANUAL_ACCOMMODATION_CHAIN_UPDATE_FILTER_CREATED_DATE_LTE';
export const UPDATE_FILTER_CREATOR = 'MANUAL_ACCOMMODATION_CHAIN_UPDATE_FILTER_CREATOR';
export const UPDATE_FILTER_LAST_AUTHOR = 'MANUAL_ACCOMMODATION_CHAIN_UPDATE_FILTER_LAST_AUTHOR';
export const UPDATE_FILTER_MODIFIED_DATE_GTE = 'MANUAL_ACCOMMODATION_CHAIN_UPDATE_FILTER_MODIFIED_DATE_GTE';
export const UPDATE_FILTER_MODIFIED_DATE_LTE = 'MANUAL_ACCOMMODATION_CHAIN_UPDATE_FILTER_MODIFIED_DATE_LTE';
export const UPDATE_FILTER_NAME = 'MANUAL_ACCOMMODATION_CHAIN_UPDATE_FILTER_NAME';
export const UPDATE_FILTER_PERIOD = 'MANUAL_ACCOMMODATION_CHAIN_UPDATE_FILTER_PERIOD';
export const UPDATE_FILTER_PERIOD_TYPE = 'MANUAL_ACCOMMODATION_CHAIN_UPDATE_FILTER_PERIOD_TYPE';
export const UPDATE_NAME = 'MANUAL_ACCOMMODATION_CHAIN_UPDATE_NAME';
export const SET_COLUMNS = 'MANUAL_ACCOMMODATION_CHAIN_SET_COLUMNS';
export const RESIZE_COLUMN = 'MANUAL_ACCOMMODATION_CHAIN_RESIZE_COLUMN';


interface SetColumnsAction {
    type: typeof SET_COLUMNS,
    payload: Column[]
}

interface ResizeColumnAction {
    type: typeof RESIZE_COLUMN,
    payload: { field_name: string; width: number }
}

interface AddPreferencesAction {
    type: typeof ADD_PREFERENCES,
    payload: Preferences[]
}

interface MoveDownColumnAction {
    type: typeof MOVE_DOWN_COLUMN,
    payload: number
}

interface MoveUpColumnAction {
    type: typeof MOVE_UP_COLUMN,
    payload: number
}

interface ResetChainAction {
    type: typeof RESET_CHAIN
}

interface ResetFiltersAction {
    type: typeof RESET_FILTERS
}

interface SetChainAction {
    type: typeof SET_CHAIN,
    payload: ManualAccommodationChain
}

interface SetErrorsAction {
    type: typeof SET_ERRORS,
    payload: Error[]
}

interface SetExportTypeAction {
    type: typeof SET_EXPORT_TYPE,
    payload: 'CSV' | 'PDF'
}

interface SetLimitAction {
    type: typeof SET_LIMIT,
    payload: number
}

interface SetListAction {
    type: typeof SET_LIST,
    payload: List
}

interface SetOrderByAction {
    type: typeof SET_ORDER_BY,
    payload: string
}

interface SetPageAction {
    type: typeof SET_PAGE,
    payload: number
}

interface SetPostFinishedAction {
    type: typeof SET_POST_FINISHED
}

interface SetPreferencesAction {
    type: typeof SET_PREFERENCES,
    payload: Preferences[]
}

interface SetRunningAction {
    type: typeof SET_RUNNING,
    payload: boolean
}

interface SetSearchAction {
    type: typeof SET_SEARCH,
    payload: string
}

interface ToggleColumnAction {
    type: typeof TOGGLE_COLUMN,
    payload: number
}

interface ToggleNewAction {
    type: typeof TOGGLE_CREATE
}

interface ToggleEditAction {
    type: typeof TOGGLE_EDIT
}

interface ToggleExportAction {
    type: typeof TOGGLE_EXPORT,
    payload: boolean
}

interface ToggleExportFullAction {
    type: typeof TOGGLE_EXPORT_FULL
}

interface ToggleFiltersAction {
    type: typeof TOGGLE_FILTERS
}

interface ToggleRefreshAction {
    type: typeof TOGGLE_REFRESH
}

interface UpdateFilterCreatedDateGteAction {
    type: typeof UPDATE_FILTER_CREATED_DATE_GTE,
    payload: Date | null
}

interface UpdateFilterCreatedDateLteAction {
    type: typeof UPDATE_FILTER_CREATED_DATE_LTE,
    payload: Date | null
}

interface UpdateFilterCreatorAction {
    type: typeof UPDATE_FILTER_CREATOR,
    payload: string
}

interface UpdateFilterLastAuthorAction {
    type: typeof UPDATE_FILTER_LAST_AUTHOR,
    payload: string
}

interface UpdateFilterModifiedDateGteAction {
    type: typeof UPDATE_FILTER_MODIFIED_DATE_GTE,
    payload: Date | null
}

interface UpdateFilterModifiedDateLteAction {
    type: typeof UPDATE_FILTER_MODIFIED_DATE_LTE,
    payload: Date | null
}

interface UpdateFilterNameAction {
    type: typeof UPDATE_FILTER_NAME,
    payload: string
}

interface UpdateFilterPeriodAction {
    type: typeof UPDATE_FILTER_PERIOD,
    payload: 'CREATION' | 'MODIFICATION'
}

interface UpdateFilterPeriodTypeAction {
    type: typeof UPDATE_FILTER_PERIOD_TYPE,
    payload: number
}

interface UpdateNameAction {
    type: typeof UPDATE_NAME,
    payload: string
}

export type ManualAccommodationChainActionTypes =
    SetColumnsAction |
    ResizeColumnAction |
    AddPreferencesAction |
    MoveDownColumnAction |
    MoveUpColumnAction |
    ResetChainAction |
    ResetFiltersAction |
    SetChainAction |
    SetErrorsAction |
    SetExportTypeAction |
    SetLimitAction |
    SetListAction |
    SetOrderByAction |
    SetPageAction |
    SetPostFinishedAction |
    SetPreferencesAction |
    SetRunningAction |
    SetSearchAction |
    ToggleColumnAction |
    ToggleNewAction |
    ToggleEditAction |
    ToggleExportAction |
    ToggleExportFullAction |
    ToggleFiltersAction |
    ToggleRefreshAction |
    UpdateFilterCreatedDateGteAction |
    UpdateFilterCreatedDateLteAction |
    UpdateFilterCreatorAction |
    UpdateFilterLastAuthorAction |
    UpdateFilterModifiedDateGteAction |
    UpdateFilterModifiedDateLteAction |
    UpdateFilterNameAction |
    UpdateFilterPeriodAction |
    UpdateFilterPeriodTypeAction |
    UpdateNameAction;